module.exports = __webpack_public_path__ + "img/Pic_Tc_ZWQX.b4f5a441.png";